<script setup lang="ts">
defineOptions({
  name: 'LeistungenPage'
})
</script>

<template>
  <div>
    <Head>
      <Title>Leistungen</Title>
      <Meta
        name="description"
        content="Generalplanung, Baumanagement und Projektmanagement – die Leistungen von johnsenpartner. architekten im Überblick."
      />
    </Head>
    <LeistungenIntro />
    <LeistungenSection
      direction="right"
      title="Generalplanung"
      number="1"
      text="Wir begleiten Sie von der ersten Idee bis zum fertigen Gebäude. Wir planen unabhängig von Produkten, System- oder Modulbau so flexibel das alle gängigen Produkte wunschgemäß Berücksichtigung finden. Dabei arbeiten wir von der Projektentwicklung über die Genehmigungsplanung zur Ausführungsplanung ganzheitlich und einfach, mit unseren Partnern aus der Tragwerksplanung, TGA, dem Brandschutz oder Tiefbau. Sprechen Sie uns an!"
      :images="['/images/leistungen/leistungen_1_1.webp', '/images/leistungen/leistungen_1_2.webp']"
      main-image="/images/leistungen/leistungen_1.webp"
    />
    <LeistungenSection
      direction="left"
      title="Baumanagement"
      number="2"
      text="Wir vereinen die integrale Planung mit unseren Netzwerk der ausführenden Firmen und unseren erfahrenen Bauleitern aus der Abwicklung. Wir steuern die Termine und führen die Kosten zu Ihren Gunsten. So setzten wir die gewünschte Qualität bis zur Schlüsselübergabe für Sie um. Sprechen Sie uns an!"
      :images="['/images/leistungen/leistungen_2_1.webp', '/images/leistungen/leistungen_2.webp']"
      main-image="/images/leistungen/leistungen_2.webp"
    />
    <LeistungenSection
      direction="right"
      title="Projektmanagement"
      number="3"
      text="Wir steuern für Sie im Projekt die Kosten, Termine und Qualitäten. Als unabhängiger und erfahrener Partner bringen wir Ihnen Übersicht, Transparenz und Sicherheit bei Ihre Entscheidungen. Ob Wohnungsbaugesellschaften, Immobilienbranche oder Großunternehmen, wir unterstützen Sie direkt oder in Ihren Abteilungen. Sprechen Sie uns an!"
      :images="['/images/leistungen/leistungen_3_1.webp', '/images/leistungen/leistungen_3_2.webp']"
      main-image="/images/leistungen/leistungen_3.webp"
    />
  </div>
</template>
